import Component from "../core/Component";

export default class DropdownSearch extends Component {
   constructor(element) {
      super(element);

      this.ref = {
         toggler: null,
         input: null,
         results: null,
         default: null,
         selected: null,
         items: [],
      };

      this.options;
      this.state = false;
      this.listenerState = false;
   }

   prepare() {
      const active = this.ref.results.querySelector(".choosen");
      if (active) this.selectItem(active, 1);

      document.addEventListener("click", (event) => {
         const withinBoundaries = event.composedPath().includes(this.element);
         if (!withinBoundaries && this.state) this.toggleDropdown();
      });
      this.ref.toggler.addEventListener("click", (e) => {
         this.toggleDropdown();
         //if (window.innerWidth < 768) this.scrollToView(e);
      });
      this.ref.input.addEventListener("keyup", () => this.filterFunction());
   }

   toggleDropdown() {
      this.state = !this.state;
      this.element.classList.toggle("open");
      if (this.element.classList.contains("open")) this.ref.input.focus();
      this.options = this.ref.results.querySelectorAll(".item");

      if (!this.listenerState) this.addEventListeners();
   }

   addEventListeners() {
      this.options.forEach((el) => {
         el.addEventListener("click", (e) => this.selectItem(e.target));
      });
      this.listenerState = true;
   }

   filterFunction() {
      let filter = this.ref.input.value
         .toLowerCase()
         .normalize("NFD")
         .replace(/[\u0300-\u036f]/g, "");

      this.options.forEach((el) => {
         let string = el.innerText
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
         if (string.indexOf(filter) > -1) {
            el.classList.remove("hidden");
         } else {
            el.classList.add("hidden");
         }
      });
   }

   // akce on click - napojit na cokoliv
   selectItem(target, initSeq) {
      this.ref.selected.innerHTML = "";
      this.ref.selected.appendChild(target.cloneNode(true));
      if (!initSeq) {
         this.toggleDropdown();
         this.options.forEach((ele) => ele.classList.remove("choosen"));
         target.classList.add("choosen");
      }
      this.ref.default.style.display = "none";
      this.ref.selected.style.display = "block";
      this.ref.input.value = "";
      if (!initSeq) this.options.forEach((ele) => ele.classList.remove("hidden"));
   }

   scrollToView(e) {
      const offsetY = 150;
      setTimeout(() => {
         const y = e.target.getBoundingClientRect().top + window.pageYOffset - offsetY;
         window.scrollTo({ top: y, behavior: "smooth" });         
      }, 100);
   }
}
